var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('equipment-table',{attrs:{"items":_vm.costBreakdown.Items,"hide-costs":false},on:{"update:items":function($event){return _vm.$set(_vm.costBreakdown, "Items", $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }